/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Just_NowInputs */

const en_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just now`)
};

const de_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade eben`)
};

const fr_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À l'instant`)
};

const es_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora mismo`)
};

const it_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprio ora`)
};

const nl_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net nu`)
};

const pl_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Właśnie teraz`)
};

const fi_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juuri nyt`)
};

const da_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lige nu`)
};

const sv_common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just nu`)
};

/**
* | output |
* | --- |
* | "Just now" |
*
* @param {Common_Just_NowInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_just_now = /** @type {((inputs?: Common_Just_NowInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Just_NowInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_just_now(inputs)
	if (locale === "fr") return fr_common_just_now(inputs)
	if (locale === "es") return es_common_just_now(inputs)
	if (locale === "it") return it_common_just_now(inputs)
	if (locale === "nl") return nl_common_just_now(inputs)
	if (locale === "pl") return pl_common_just_now(inputs)
	if (locale === "fi") return fi_common_just_now(inputs)
	if (locale === "da") return da_common_just_now(inputs)
	if (locale === "sv") return sv_common_just_now(inputs)
	return en_common_just_now(inputs)
});